import { useState, useEffect } from 'react';

/**
 * Custom hook for responsive design and mobile detection
 * @param {number} mobileBreakpoint - Width in pixels below which is considered mobile
 * @returns {object} - Object containing responsive state values
 */
const useResponsive = (mobileBreakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      
      // Check if mobile based on breakpoint
      setIsMobile(window.innerWidth <= mobileBreakpoint);
    }
    
    // Add event listener
    window.addEventListener("resize", handleResize);
    
    // Call handler right away so state gets updated with initial window size
    handleResize();
    
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, [mobileBreakpoint]); // Only re-run if breakpoint changes

  return {
    isMobile,
    windowSize,
    isDesktop: !isMobile,
    // Convenience breakpoints
    isSmallMobile: windowSize.width <= 480,
    isTablet: windowSize.width > mobileBreakpoint && windowSize.width <= 1024,
  };
};

export default useResponsive;
